<div class="settings-profile">
  <andor-fieldset>
    <div
      class="avatar-picker"
      [class.drag-over]="dragOver()"
      (dragover)="onAvatarDragOver($event)"
      (dragleave)="onAvatarDragLeave()"
      (drop)="onAvatarDrop($event)">
      <button
        type="button"
        class="avatar-picker__trigger"
        [andorTooltip]="'Set avatar' | translate"
        [attr.aria-label]="'Set avatar' | translate"
        (click)="openAvatarPicker()">
        <span class="avatar-picker__image">
          <img [src]="avatarUrl()" [alt]="'Your avatar' | translate" crossorigin="anonymous" />
          <span class="avatar-picker__overlay">
            <fa-icon [icon]="faCamera"></fa-icon>
          </span>
        </span>
        <span class="avatar-picker__hint">
          <fa-icon class="avatar-picker__hint-icon" [icon]="faImagePortrait"></fa-icon>
          <span class="avatar-picker__hint-text">
            <strong>{{ 'Set avatar' | translate }}</strong>
            <small>{{ 'Drag &amp; drop or click to set' | translate }}</small>
          </span>
        </span>
      </button>

      @if (hasCustomAvatar()) {
        <button
          type="button"
          class="avatar-picker__remove"
          [andorTooltip]="'Remove avatar' | translate"
          [attr.aria-label]="'Remove avatar' | translate"
          (click)="removeAvatar()">
          <fa-icon [icon]="faTrashCan"></fa-icon>
        </button>
      }

      <input
        #avatarInput
        type="file"
        accept="image/*"
        class="avatar-picker__input"
        (change)="onAvatarInputChange($event)" />
    </div>
    @if (uploadError()) {
      <p class="avatar-picker__error">{{ uploadError()! | translate }}</p>
    }
    <div class="avatar-note">
      <fa-icon class="avatar-note__icon" [icon]="faLock"></fa-icon>
      <span class="avatar-note__text">
        {{
          'Your avatar is stored only on this device. It is shared with other participants as profile data — end-to-end encrypted when E2E encryption is active.'
            | translate
        }}
      </span>
    </div>
    <div class="spacer"></div>
    <andor-text-field
      [formControl]="userNameControl"
      [labelTooltip]="'Your username that gets displayed to other participants.' | translate"
      [errorMessages]="{
        required: 'Your name is required.' | translate,
        minlength: 'Your name must be at least 3 characters long.' | translate,
        pattern: 'Your name must start with a letter.' | translate,
      }"
      [label]="'Display Name' | translate"
      [trailingButton]="saveDisplayNameAction"></andor-text-field>
    <div class="spacer"></div>
    <andor-text-field
      #statusField
      [formControl]="statusMessageControl"
      [trailingButton]="updateStatusAction"
      [inlineActions]="statusMessageInlineActions"
      inlineActionsPosition="end"
      [labelTooltip]="'Set your current status message.' | translate"
      [errorMessages]="{
        maxlength: 'The length of the status text must not exceed 100 letters.' | translate,
      }"
      [placeholder]="'I\'m currently busy with...' | translate"
      [label]="'Status Message' | translate"></andor-text-field>
    <div class="spacer"></div>
    <andor-mat-toggle-wrapper
      label="{{ 'Set Away' | translate }}"
      [tooltipText]="'Mark yourself as away. Others will see an orange status dot.' | translate">
      <mat-slide-toggle (toggleChange)="toggleStatus()" [checked]="isAway()"></mat-slide-toggle>
    </andor-mat-toggle-wrapper>
  </andor-fieldset>
</div>

<andor-context-menu #emojiMenu mode="transparent" yPosition="above" xPosition="after">
  <andor-emoji-picker (selectedEmoji)="appendEmoji($event); emojiMenu.close()"></andor-emoji-picker>
</andor-context-menu>
